module.exports = __webpack_public_path__ + "static/media/option-2_active.f270ae6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/message/option-2_active.png
// module id = 833
// module chunks = 0